function initLensPower() {

    console.log("Init once");
    console.log($('.gpo-container').length);
    console.log($('#checkbox-1_1').length);
    console.log($('.gpo-select select').length);

    // Your existing code here
    if($('.gpo-container').length > 0){
      //console.log('IN');
        const $doubleLens = $('#checkbox-1_1');
        const $mainQty    = $('input[name="quantity"]');
        const $shadowQty  = $('input[name="custom_quantity"]');

        $('.product-form__quantity').hide();
        $('.lenses-power-main-block').show();

        function updateCart() {

            let qty = parseInt($shadowQty.val(), 10);

            if (isNaN(qty) || qty < 1) {
                qty = 1;
                $shadowQty.val(qty);
            }

            // Double quantity if Double Lens is checked
            let finalQty = $doubleLens.is(':checked') ? qty * 2 : qty;

            // Update Shopify quantity
            $mainQty.val(finalQty).trigger('change');

            // Toggle price
            //$('.default-price').toggle(!$doubleLens.is(':checked'));
            $('.twice-price').toggle($doubleLens.is(':checked'));
        }

        // Initial load
        updateCart();

        // Double Lens checkbox
        $(document).on('change', '#checkbox-1_1', function () {
            updateCart();
        });

        // Manual quantity input
        $(document).on('input change', 'input[name="custom_quantity"]', function () {
            updateCart();
        });

        // Plus button
        $(document).on('click', '.custom-qty-plus', function (e) {
            e.preventDefault();

            let qty = parseInt($shadowQty.val(), 10) || 1;
            $shadowQty.val(qty + 1);

            updateCart();
        });

        // Minus button
        $(document).on('click', '.custom-qty-minus', function (e) {
            e.preventDefault();

            let min = parseInt($shadowQty.attr('min')) || 1;
            let qty = parseInt($shadowQty.val(), 10) || min;

            if (qty > min) {
                $shadowQty.val(qty - 1);
            }

            updateCart();
        });

       
        function updateTotalPrice() {
            const $price = $('.default-price');
            let basePrice = parseFloat($price.data('price')); // stored in cents e.g. 11250 = ฿112.50
            const qty = parseInt($('[name=quantity]').val(), 10) || 1;

            // Check the show-addon-for-option radio (Yes / No)
            // If the addon group exists and "No" is selected -> skip extra_block, use default price
            const $addonGroup = $('.gpo-element.show-addon-for-option');
            const addonSelected = $addonGroup.length
                ? $addonGroup.find('input[type="radio"]:checked').val()
                : null;

            if (!$addonGroup.length || addonSelected === 'Yes') {
                // Check for an extra_block class (10, 20, 30, 40, 50) inside .gpo-element
                const extraClasses = ['10_extra_block', '20_extra_block', '30_extra_block', '40_extra_block', '50_extra_block'];
                let extraAmount = 0;
                extraClasses.forEach(function (cls) {
                    if ($('.gpo-element.' + cls).length) {
                        extraAmount = parseInt(cls, 10); // extracts leading number (10, 20, 30, 40, 50)
                    }
                });
                // Convert extra amount to cents to match basePrice format, then add
                basePrice = basePrice + (extraAmount * 100);
            }
            // If "No" selected -> basePrice stays at the original default price

            // Per-unit price in display currency
            const unitPrice = basePrice / 100;

            // Update .default-price display to show the adjusted per-unit price
            // (data-price attribute is intentionally left unchanged so every call
            //  re-reads the original base price and avoids drift)
            $price.html($price.find('svg')[0].outerHTML + ' ' + unitPrice.toFixed(2));

            const total = unitPrice * qty;

            $('.twice-price').html(
                'x ' + qty + ' = ' +
                $price.find('svg')[0].outerHTML +
                ' ' + total.toFixed(2)
            );
        }

        // Initial load
        updateTotalPrice();

        // Shopify quantity input
        $(document).on('input change', '[name=quantity]', updateTotalPrice);

        // If Shopify updates quantity via +/- buttons after click
        $(document).on('click', '.quantity__button', function () {
            setTimeout(updateTotalPrice, 0);
        });

        // Handle Yes / No addon radio toggle
        function handleAddonToggle() {
            const $addonGroup = $('.gpo-element.show-addon-for-option');
            if (!$addonGroup.length) return; // no addon radio on this product — do nothing

            const selected = $addonGroup.find('input[type="radio"]:checked').val();

            if (selected === 'No') {
                // ── REVERT to standard Shopify behaviour ──────────────────────
                $('.lenses-power-main-block').hide();   // hide the whole power/price block
                $('.product-form__quantity').show();    // restore standard qty input
                $mainQty.val(1).trigger('change');      // reset Shopify qty to 1

                // Restore default-price display to the original base price
                const $price = $('.default-price');
                const basePrice = parseFloat($price.data('price')) / 100;
                $price.html($price.find('svg')[0].outerHTML + ' ' + basePrice.toFixed(2));

            } else {
                // ── YES selected — restore full lens-power behaviour ──────────
                $('.lenses-power-main-block').show();
                $('.product-form__quantity').hide();
                updateCart();           // re-sync custom qty → Shopify qty
                updateTotalPrice();     // re-apply extra_block pricing
            }
        }

        // Run once on load to set the correct initial state
        handleAddonToggle();

        // Re-run whenever the Yes / No radio changes
        $(document).on('change', '.gpo-element.show-addon-for-option input[type="radio"]', handleAddonToggle);


        function toggleLensesPriceBlock() {
            let hasValue = false;

            $('.gpo-select select').each(function () {
              //console.log($(this).val());
                if ($(this).val() !== null) {
                    hasValue = true;
                    return false; // Exit loop
                }
            });
            if(hasValue == false){
              $('.lenses-price-block').hide();  
            }else{
              $('.lenses-price-block').show();
            }

            //console.log(hasValue);
        }

        // Initial check
        toggleLensesPriceBlock();

        // Check whenever a select changes
        $(document).on('change', '.gpo-select select', toggleLensesPriceBlock);
        

    }

}

const observer = new MutationObserver(function () {

    if (
        $('.gpo-container').length &&
        $('#checkbox-1_1').length
    ) {
        observer.disconnect();
        initLensPower();
    }

});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

// Default state: lenses power block hidden, standard qty visible.
// initLensPower() will reverse this when .gpo-container is present.
$('.lenses-power-main-block').hide();
$('.product-form__quantity').show();



jQuery(document).ready(function($){


    
    jQuery(".slick-prev.slick-arrow").attr( "title", "Previous" );
    jQuery(".slick-next.slick-arrow").attr( "title", "Next" );

    //Brands Slider
    jQuery('.brands-slider').slick({
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        speed: 1000,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });

    
    //Testimonials Slider
    jQuery('.testim-slider').slick({
        infinite: true,
        dots: true,
        arrows: false,
        autoplay: true,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

  //Products Slider
    jQuery('.products-modal-slider').slick({
        infinite: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
    });

    $(document).ready(function () {
      const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'open'
          ) {
            const modal = $(mutation.target);
            if (modal.is('[open]')) {
              $('.products-modal-arrow').addClass('d-block');
            } else {
              $('.products-modal-arrow').removeClass('d-block');
            }
          }
        });
      });

      $('product-modal').each(function () {
        observer.observe(this, {
          attributes: true,
          attributeFilter: ['open'],
        });
      });
    });


});//End
